/**
 * Formats a byte count as a human-readable string.
 *
 * Examples:
 *   formatBytes(800)               // "800 B"
 *   formatBytes(2048)              // "2 KB"
 *   formatBytes(2.4 * 1024 * 1024) // "2.4 MB"
 */
export function formatBytes(bytes) {
    if (bytes >= 1024 * 1024) {
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }
    if (bytes >= 1024) {
        return `${Math.round(bytes / 1024)} KB`;
    }
    return `${bytes} B`;
}
